// extracted by mini-css-extract-plugin
export default {"checkout":"Checkout_checkout__7CYaK","content":"Checkout_content__P60L3","action":"Checkout_action__bmHvp","btn":"Checkout_btn__hbV6n"};